"use strict";

exports.__esModule = true;
exports.TicketTypeEditor = TicketTypeEditor;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _FormGroupField = require("../../Form/FormGroupField");
var _Form = require("../../Form");
var _TicketTypeListContext = require("../TicketTypeListContext");
var _Core = require("../../Core");
var _System = require("../../../System");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var EditorForm = _styledComponents["default"].form.withConfig({
  displayName: "TicketTypeEditor__EditorForm",
  componentId: "sc-18jpxo6-0"
})(["display:flex;flex:1;overflow:auto;flex-direction:column;height:100%;"]);
var EditorBody = _styledComponents["default"].div.withConfig({
  displayName: "TicketTypeEditor__EditorBody",
  componentId: "sc-18jpxo6-1"
})(["padding:1rem;display:flex;flex-direction:column;"]);

/**
 * Ticket type editor form
 */
function TicketTypeEditor(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var ticketTypes = _react["default"].useContext(_TicketTypeListContext.TicketTypeListContext);
  function handleSubmit(values) {
    var id = props.id,
      onSubmit = props.onSubmit;
    id ? onSubmit(values, id) : onSubmit(values);
  }
  function validateLabel(value) {
    // check if we already have this one
    var tt = ticketTypes.getByValue(value);
    if (tt && tt.id !== id) {
      return translate("TicketTypeEditor.validateLabel.duplicate", "Label already exists.");
    }
    if (!value || !value.trim()) {
      return translate("TicketTypeEditor.validateLabel.required", "Label is required.");
    }
  }
  var value = props.value,
    id = props.id;
  var initialValues = Object.assign({}, value);
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    initialValues: Object.assign({}, initialValues),
    onSubmit: handleSubmit
  }, function (_ref) {
    var handleSubmit = _ref.handleSubmit,
      pristine = _ref.pristine,
      invalid = _ref.invalid;
    return /*#__PURE__*/_react["default"].createElement(EditorForm, {
      "data-testid": "TicketTypeEditor",
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      style: {
        marginLeft: "auto"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "save",
      type: "submit",
      icon: _icons.IconNames.FLOPPY_DISK,
      intent: _core.Intent.PRIMARY,
      text: translate("TicketTypeEditor.saveButton.text", "Save"),
      disabled: pristine || invalid
    }), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      minimal: true,
      end: true,
      icon: _icons.IconNames.CROSS,
      to: (0, _System.getScreenLocation)("TicketTypes"),
      text: translate("TicketTypeEditor.cancelButton.text", "Cancel")
    }))), /*#__PURE__*/_react["default"].createElement(EditorBody, null, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      validate: validateLabel,
      name: "value",
      label: translate("TicketTypeEditor.label", "Label")
    }, function (_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
        "data-testid": "label"
      }, input));
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "color",
      label: translate("TicketTypeEditor.color", "Color")
    }, function (_ref3) {
      var input = _ref3.input;
      return /*#__PURE__*/_react["default"].createElement(_Form.ColorPicker, _extends({
        value: value
      }, input));
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "enabled",
      type: "checkbox"
    }, function (_ref4) {
      var input = _ref4.input;
      return /*#__PURE__*/_react["default"].createElement(_core.Switch, _extends({
        label: translate("TicketTypeEditor.enabled.fieldValue", "Enabled")
      }, input));
    })));
  });
}